import gql from "graphql-tag";

export const CompleteTutorial = gql`
  mutation CompleteTutorial($name: String!, $version: Int!) {
    completeTutorial(tutorial: { name: $name, version: $version })
  }
`;
